"use client";

import { c as _c } from "react/compiler-runtime";
import { UnstyledButton } from "@opensea/ui-kit";
import { Search } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useShallow } from "zustand/react/shallow";
import { useExpandedSearchStore } from "../expanded-search/ExpandedSearchStore";
export function MobileNavSearch() {
  const $ = _c(8);
  const [, setOpen] = useExpandedSearchStore(useShallow(_temp));
  const t = useTranslations("MobileNavSearch");
  let t0;
  if ($[0] !== setOpen) {
    t0 = () => {
      setOpen(true);
    };
    $[0] = setOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("search");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Search />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t1) {
    t3 = <UnstyledButton className="mr-[-2px]" onClick={t0} title={t1}>{t2}</UnstyledButton>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(state) {
  return [state.open, state.setOpen];
}